
export const nestTaxonomyChildren = (taxonomy, idPropertyName, parentIdPropertyName) => {
  let childTerms = {};
  let parentId;
  taxonomy.forEach(term => {
    parentId = parseInt(term[parentIdPropertyName]);
    if (parentId) {
      if (!childTerms[parentId]) {
        childTerms[parentId] = [];
      }
      childTerms[parentId].push(term);
      term.isChild = true;
    }
  });
  let termId;
  taxonomy.forEach(term => {
    termId = parseInt(term[idPropertyName]);
    if (childTerms[termId]) {
      term.children = childTerms[termId];
    }
  });
  return taxonomy.filter(term => {
    return !term.isChild;
  });
};
